import React from 'react';
import { Alert, Platform, Text, TouchableOpacity, View } from 'react-native';
import i18n from './../util/i18n';
import { deleteCategory, getCategories } from '../services/category.service';
import { Button, Card, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

i18n.locale = navigator.language;

class Categories extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            categories: []
        };
    }

    async componentDidMount() {
        this.focusListener = this.props.navigation.addListener('focus', () => {
            this.setCategories();
        });
        this.setCategories();
    }

    componentWillUnmount() {
        if (this.focusListener) {
            this.focusListener();
        }
    }

    setCategories = async () => {
        let categories = await getCategories();
        this.setState({ categories: categories?.categories ?? [] });
    }

    render() {
        return (
            <View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                    <Text style={{ padding: 10, fontSize: 25 }}>
                        {i18n.t('categories')}
                    </Text>
                    <Button
                        size='small'
                        variant='contained'
                        onClick={() => {
                            this.props.navigation.replace('AddEditCategory');
                        }}
                    >
                        + {i18n.t('add')}
                    </Button>
                </View>

                <View>





                <TableContainer component={Card}>
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{i18n.t('sl_no')}</TableCell>
                                    <TableCell>{i18n.t('name')}</TableCell>
                                    <TableCell align='center'>{i18n.t('no_points')}</TableCell>
                                    <TableCell align='right'>{i18n.t('number_of_songs')}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(this.state.categories.length > 0) ? this.state.categories.map((category, index) => {
                                    return (
                                        <TableRow key={category._id}>
                                            <TableCell size='small'>{category.position}</TableCell>
                                            <TableCell size='small'>{category.name}</TableCell>
                                            <TableCell size='small' align='center'>{category.no_points ? i18n.t('yes') : ''}</TableCell>
                                            <TableCell size='small' align='right'>{category.songs}</TableCell>
                                            <TableCell size='small'>
                                                <Stack spacing={2} direction='row' alignItems='center' justifyContent={'space-around'} sx={{ margin: 1 }}>
                                                    <Button
                                                        size='small'
                                                        variant='contained'
                                                        onClick={() => {
                                                            this.props.navigation.navigate('AddEditCategory', { category: category._id });
                                                        }}
                                                    >
                                                        {i18n.t('edit')}
                                                    </Button>
                                                    <Button
                                                        size='small'
                                                        variant='outlined'
                                                        onClick={() => {
                                                            this.props.navigation.navigate('Songs', { category: category._id });
                                                        }}
                                                    >
                                                        {i18n.t('songs')}
                                                    </Button>
                                                    <Button
                                                        size='small'
                                                        variant='contained'
                                                        color='error'
                                                        onClick={async () => {
                                                            // delete category
                                                            if (Platform.OS === 'web') {
                                                                if (window.confirm(i18n.t('are_you_sure_you_want_to_delete_this_category'))) {
                                                                    await deleteCategory(category._id);
                                                                    this.setCategories();
                                                                }
                                                            } else {
                                                                Alert.alert(
                                                                    i18n.t('confirm_delete'),
                                                                    i18n.t('are_you_sure_you_want_to_delete_this_category'),
                                                                    [
                                                                        {
                                                                            text: i18n.t('cancel'),
                                                                            onPress: () => console.log('Cancel Pressed'),
                                                                            style: 'cancel'
                                                                        },
                                                                        {
                                                                            text: i18n.t('delete'),
                                                                            onPress: async () => {
                                                                                await deleteCategory(category._id);
                                                                                this.setCategories();
                                                                            }
                                                                        }
                                                                    ]
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {i18n.t('delete')}
                                                    </Button>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>






                    {/* <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                        {(this.state.categories.length > 0) ? this.state.categories.map((category, index) => {
                            return (
                                <TableWrapper
                                    key={category._id}
                                    style={{ flexDirection: 'row', justifyContent: 'space-between' }}
                                >
                                    <Cell data={category.position} textStyle={{ margin: 6, textAlign: 'left', fontSize: 20 }} />
                                    <Cell data={category.name} textStyle={{ margin: 6, textAlign: 'left', fontSize: 20 }} />
                                    <Cell data={
                                        <Stack spacing={2} direction='row' alignItems='center' justifyContent={'space-around'} sx={{ margin: 1 }}>
                                            <Button
                                                size='small'
                                                variant='contained'
                                                onClick={() => {
                                                    this.props.navigation.replace('AddEditCategory', { category: category._id });
                                                }}
                                            >
                                                {i18n.t('edit')}
                                            </Button>
                                            <Button
                                                size='small'
                                                variant='outlined'
                                                onClick={() => {
                                                    this.props.navigation.replace('Songs', { category: category._id });
                                                }}
                                            >
                                                {i18n.t('songs')}
                                            </Button>
                                            <Button
                                                size='small'
                                                variant='contained'
                                                color='error'
                                                onClick={() => {
                                                    // delete category
                                                    if (Platform.OS === 'web') {
                                                        if (window.confirm(i18n.t('are_you_sure_you_want_to_delete_this_category'))) {
                                                            deleteCategory(category._id);
                                                            this.setCategories();
                                                        }
                                                    } else {
                                                        Alert.alert(
                                                            i18n.t('confirm_delete'),
                                                            i18n.t('are_you_sure_you_want_to_delete_this_category'),
                                                            [
                                                                {
                                                                    text: i18n.t('cancel'),
                                                                    onPress: () => console.log('Cancel Pressed'),
                                                                    style: 'cancel'
                                                                },
                                                                {
                                                                    text: i18n.t('delete'),
                                                                    onPress: async () => {
                                                                        await deleteCategory(category._id);
                                                                        this.setCategories();
                                                                    }
                                                                }
                                                            ]
                                                        );
                                                    }
                                                }}
                                            >
                                                {i18n.t('delete')}
                                            </Button>
                                        </Stack>
                                    } textStyle={{ margin: 6, textAlign: 'left', fontSize: 20, paddingLeft: 10 }} />
                                </TableWrapper>
                            )
                        }) : null}
                    </Table> */}
                </View>
                
                
            </View>
        )
    }
}

export default Categories;
